import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IncidentService {
  constructor(private httpClient: HttpClient) {}

  userBase: string = sessionStorage.getItem('incidentsBase');
  userYear: string = sessionStorage.getItem('incidentsYear');
  userId: string = JSON.parse(sessionStorage.getItem('userInfo'))?.id;

  private _madbIncidentList = new BehaviorSubject<any>(null);
  public readonly madbIncidentList = this._madbIncidentList.asObservable();

  getSingleMadbIncident(id: number): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/incidents/${id}`);
  }

  getMadbIncidents(): Observable<any> {
    return this.httpClient.get(
      `${environment.API_URL}/incidents/?limit=999999&offset=0&year=${this.userYear}`
    );
  }

  getSingleMarsIncident(incidentId: number): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.API_URL}/mars/incident/fetch?incidentId=${incidentId}`
    );
  }

  getMarsIncidents(): Observable<any> {
    // here we set the year to the current year if we do not have a year in the session storage
    const year = this.userYear === null ? new Date().getFullYear() : this.userYear;
    return this.httpClient.get<any>(
      `${environment.API_URL}/mars/incidentlist/fetch?year=${year}`
    );
  }

  saveMarsIncident(incident: any): Observable<any> {
    this.userId = JSON.parse(sessionStorage.getItem('userInfo'))?.id;
    return this.httpClient.post<any>(
      `${environment.API_URL}/mars/incident/add?userId=${this.userId}`,
      incident
    );
  }

  deleteIncident(incidentId: number): Observable<any> {
    return this.httpClient.delete<any>(
      `${environment.API_URL}/mars/incident/${incidentId}/delete`
    );
  }

  updateMarsIncident(incident: any): Observable<any> {
    const id = JSON.parse(sessionStorage.getItem('userInfo'))?.id;
    return this.httpClient.put<any>(
      `${environment.API_URL}/mars/incident/update?userId=${id}`,
      incident
    );
  }

  getSingleAircraft(id: number): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/travelmodes/${id}`);
  }

  getJumpers(baseId: number): Observable<any> {
    return this.httpClient.get(`${environment.API_URL}/jumpers?baseId=${baseId}`);
  }

  getMadbIncidentsFilteredByString = (searchText: string) => {
    return this.httpClient.get(`${environment.API_URL}/incidentsearchbyname?searchText=${searchText}`,
    {
      headers: { 'Content-Type': 'application/vnd.api+json' },
    })
    .subscribe({
      next: (response: any) => {
        this._madbIncidentList.next(response);
      },
      error: (error) => {
        console.log('error', error);
      },
    })
  }

  saveIncidentImage(image: any, slotNumber: any, incidentId: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', image);
    return this.httpClient.post(
      `${environment.API_URL}/mars/uploadmedia?slotNumber=${slotNumber}&incidentId=${incidentId}`,
      formData
    );
  }

  deleteMedia(incidentId: any, slotNumber: any): Observable<any> {
    return this.httpClient.delete(
      `${environment.API_URL}/mars/deletemedia?incidentId=${incidentId}&slotNumber=${slotNumber}`
    );
  }
}
